import { Box, ChakraProvider, theme } from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ColorModeSwitcher } from './ColorModeSwitcher';
import AuthOptions from './components/auth/AuthOptions';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import Favorites from './components/pages/Favorites';
import Home from './components/pages/Home';
import MovieDetails from './components/pages/MovieDetails';
import MoviesList from './components/pages/MoviesList';
import Search from './components/pages/Search';
import UserContext from './context/userContext';

function App() {
  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined,
  });

  useEffect(() => {
    const checkLoggedIn = async () => {
      let token = localStorage.getItem('auth-token');
      if (token === null) {
        localStorage.setItem('auth-token', '');
        token = '';
      }
      const tokenResponse = await axios.post(
        'https://mern-stack-movies-app.herokuapp.com/consumers/tokenIsValid',
        null,
        {
          headers: { 'x-auth-token': token },
        }
      );
      if (tokenResponse.data) {
        const userRes = await axios.get(
          'https://mern-stack-movies-app.herokuapp.com/consumers/',
          {
            headers: { 'x-auth-token': token },
          }
        );
        setUserData({
          token,
          user: userRes.data,
        });
      }
    };
    checkLoggedIn();
  }, []);

  return (
    <BrowserRouter>
      <UserContext.Provider value={{ userData, setUserData }}>
        <ChakraProvider theme={theme}>
          <ColorModeSwitcher justifySelf="flex-end" />
          <Box minH="calc(100vh - 80px)">
            <Header />
            <Routes>
              <Route path="/" element={<MoviesList />} />
              <Route exact path="/home" element={<Home />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/search" element={<Search />} />
              <Route path="/movie/:movieId" element={<MovieDetails />} />
              <Route path="/auth" element={<AuthOptions />} />
              <Route path="/favorites" element={<Favorites />} />
            </Routes>
          </Box>
          <Footer />
        </ChakraProvider>
      </UserContext.Provider>
    </BrowserRouter>
  );
}

export default App;
